import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as RadioGroup from "@radix-ui/react-radio-group";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "../ui/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { updateProfile } from "../../services/api";
import { setRefetch, setUserData } from "../../store/reducers/listingReducer";

export const ManageNotifications = () => {
  const [loading, setLoading] = useState(false);
  const [setting, setSetting] = useState("every_listing");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector((state: any) => state.listingReducer.userData);

  useEffect(() => {
    //console.log(userData)
    if (userData) {
      console.log("userData:", userData);
      const newSetting = userData.user_preference
        ? userData.user_preference.notification_frequency
        : "every_listing";
      console.log("New setting to be set:", newSetting);
      setSetting(newSetting);
    }
  }, [userData]);

  async function changeNotificationSettings() {
    setLoading(true);
    try {
      const submitValues = { ...userData, notification_frequency: setting };
      const formData = new FormData();
      Object.keys(submitValues).forEach((key) =>
        formData.append(key, submitValues[key])
      );
      let changeResponse = await updateProfile(formData);
      if (changeResponse) {
        dispatch(setUserData(changeResponse.data.data));
      }

      dispatch(setRefetch(true));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  return (
    <div className="w-full p-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold text-gray-900">
          Manage Notifications
        </h3>
        <div className="flex">
          <button
            className="bg-primary px-4 py-2 text-white font-semibold text-sm flex gap-x-3"
            disabled={loading}
            onClick={changeNotificationSettings}
          >
            {loading ? <Spinner /> : null}
            Save
          </button>
          <button onClick={() => navigate("/")} className="h-10 w-10">
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
      </div>

      <div className="mt-6">
        <div>
          <span className=" font-semibold text-gray-900">
            Select SMS Settings
          </span>

          <RadioGroup.Root
            className="flex flex-col gap-y-3 mt-3"
            value={setting}
            onValueChange={(val) => setSetting(val)}
          >
            <div className="flex items-center gap-x-2">
              <RadioGroup.Item
                className="border-2 w-5 h-5 rounded-full"
                id="every_listing"
                value="every_listing"
              >
                <RadioGroup.Indicator className="w-full h-full flex justify-center items-center relative after:content-[' '] after:w-3 after:h-3 after:block after:bg-primary after:rounded-full" />
              </RadioGroup.Item>
              <label
                className="font-medium text-sm text-gray-700"
                htmlFor="every_listing"
              >
                Every new listing
              </label>
            </div>

            <div className="flex items-center gap-x-2">
              <RadioGroup.Item
                className="border-2 w-5 h-5 rounded-full"
                id="every_5_listings"
                value="every_5_listings"
              >
                <RadioGroup.Indicator className="w-full h-full flex justify-center items-center relative after:content-[' '] after:w-3 after:h-3 after:block after:bg-primary after:rounded-full" />
              </RadioGroup.Item>
              <label
                className="font-medium text-sm text-gray-700"
                htmlFor="every_5_listings"
              >
                Every 5 listings
              </label>
            </div>

            <div className="flex items-center gap-x-2">
              <RadioGroup.Item
                className="border-2 w-5 h-5 rounded-full"
                id="every_10_listings"
                value="every_10_listings"
              >
                <RadioGroup.Indicator className="w-full h-full flex justify-center items-center relative after:content-[' '] after:w-3 after:h-3 after:block after:bg-primary after:rounded-full" />
              </RadioGroup.Item>
              <label
                className="font-medium text-sm text-gray-700"
                htmlFor="every_10_listings"
              >
                Every 10 listings
              </label>
            </div>
          </RadioGroup.Root>
        </div>
      </div>
    </div>
  );
};
